var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDarkMode(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 18.5C6.5 18.5 4.375 17.625 2.625 15.875C0.875 14.125 0 12 0 9.5C0 7 0.875 4.875 2.625 3.125C4.375 1.375 6.5 0.5 9 0.5C9.23333 0.5 9.4625 0.508333 9.6875 0.525C9.9125 0.541667 10.1333 0.566667 10.35 0.6C9.66667 1.08333 9.12083 1.7125 8.7125 2.4875C8.30417 3.2625 8.1 4.1 8.1 5C8.1 6.5 8.625 7.775 9.675 8.825C10.725 9.875 12 10.4 13.5 10.4C14.4167 10.4 15.2583 10.1958 16.025 9.7875C16.7917 9.37917 17.4167 8.83333 17.9 8.15C17.9333 8.36667 17.9583 8.5875 17.975 8.8125C17.9917 9.0375 18 9.26667 18 9.5C18 12 17.125 14.125 15.375 15.875C13.625 17.625 11.5 18.5 9 18.5Z",
    fill: "#1C1B1F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDarkMode);
export default __webpack_public_path__ + "static/media/dark_mode.4c59545db0431b5fab96e5581f3c0952.svg";
export { ForwardRef as ReactComponent };